import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form } from 'react-bootstrap'

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  // KeyboardDateTimePicker,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import InfoIconOverlay from './InfoIconOverlay'


// import { userRegionIsEU } from '../functions/userPermissions'
// accepts type props of 'date', 'text', 'textarea', and 'number'

// asCol determines whether the component returns a boostrap Row or a React Fragment containing a boostrap Col

// Col sizes are set with default props but can be input as custom sizes

//showTimeSelect is an optional prop to add a time select to the date picker

const FormInput = (props) => {

  const {
    type,
    label,
    value,
    name,
    placeholder,
    onChange,
    asCol,
    xs,
    sm,
    md,
    lg,
    rows,
    disabled,
    required,
    readOnly,
    maxNumber,
    errorText,
    step,
    // showTimeSelect,
    // timeIntervals,
    // currentUser,
  } = props

  let infoText = props.infoText

  let Wrapper = Row

  if (asCol) {
    Wrapper = Fragment
  }

  const handleDateChange = (date, e) => {
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      onChange(date)
    } else {
      onChange(null)
    }
  }

  const handleDateKeyDown = (e) => {
    if (!e || !e.key || (e.key !== "Backspace" && e.key !== "Delete")) {
      return e.preventDefault()
    }
  }

  let formForDisplay


  if (type === 'date') {
    // let Picker = KeyboardDatePicker
    // let format = "MM/dd/yyyy"

    // if (userRegionIsEU(currentUser)) {
    //   format = "dd/MM/yyyy"
    // }
    //
    // if (showTimeSelect) {
    //   Picker = KeyboardDateTimePicker
    //   format += " hh:mm"
    // }

    let format = "MMMM d,  yyyy"

    formForDisplay = (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          disabled={disabled}
          margin="normal"
          label='Please select a date'
          format={format}
          value={value}
          required={required}
          helperText={required && !value ? errorText || 'Date is invalid' : 'Date is valid'}
          onChange={handleDateChange}
          onKeyDown={handleDateKeyDown}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          allowKeyboardControl={false}
          style={{marginRight: '20px'}}
        />
      </MuiPickersUtilsProvider>
    )
  } else if (type === 'time') {
    if (!infoText) {
      infoText = 'If the time is not known, please leave this field blank.'
    } else {
      infoText = (
        <>
          {infoText}
          <br/>
          <br/>
          <p>
            If the time is not known, please leave this field blank.
          </p>
        </>
      )
    }
    formForDisplay = (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardTimePicker
          disabled={disabled}
          margin="normal"
          format={'HH:mm'}
          value={value}
          onChange={handleDateChange}
          required={required}
          helperText='Format: HH:MM'
          onKeyDown={handleDateKeyDown}
          allowKeyboardControl={false}
        />
      </MuiPickersUtilsProvider>
    )
  } else {
    formForDisplay = (
      <Form.Control
        as={type === 'textarea' ? 'textarea' : 'input'}
        rows={rows}
        type={type}
        name={name}
        max={maxNumber}
        step={step}
        value={value}
        onChange={onChange}
        placeholder={placeholder || ''}
        onBlur={props.onBlur}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
      />
    )
  }

  return (
    <Wrapper>
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <Form.Group>
          <Form.Label>
            {label}

            {infoText ?
              <InfoIconOverlay text={infoText} />
              :
              null
            }
          </Form.Label>
          <br/>
          {formForDisplay}
        </Form.Group>
      </Col>
    </Wrapper>
  )
}

FormInput.defaultProps = {
  type: 'text',
  rows: 4,
  xs: 12,
  sm: 12,
  md: 8,
  lg: 6,
  timeIntervals: 1,
  onBlur: () => null,
  step: 'any',
}

const mapStateToProps = (state) => {
  return {
    // currentUser: state.loginReducer.currentUser,
  }
}

export default connect(mapStateToProps)(FormInput)
